import { SET_USER_PROFILE_CONTENT_HEIGHT } from './constants'

export function setContentHeight(height) {
    return {
        type: SET_USER_PROFILE_CONTENT_HEIGHT,
        data: {
            height,
        },
    }
}
